import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/landing/dist/rtu/@section5/index.js");
